<div class="page column center">
  <img src="assets/img/logo-type.png">
  <p class="error" translate>nav.move-away</p>
</div>